import PropTypes from 'prop-types';
import React from 'react';
import SecondaryNav from '../../Common/containers/SecondaryNav';

function FootballLiveCenterNav({open, opener}) {
  const props = {
    open,
    opener,
    title: "Live Scores",
    links: [
      {href: "/football/live", text: "Live Centre", exceptions: [{href: "/football/live/vidiprinter"}]},
      {href: "/football/live/vidiprinter", text: "Vidiprinter"}
    ],
    back: [
      {href: "/football", text: "Football Home"}
    ]
  };

  return (
    <SecondaryNav {...props}/>
  );
}

FootballLiveCenterNav.propTypes = {
  open: PropTypes.bool.isRequired,
  opener: PropTypes.func.isRequired
}

export default FootballLiveCenterNav



// WEBPACK FOOTER //
// ./modules/Football/nav/FootballLiveCenterNav.js